const OldSystemFrame = () => import('@/views/OldSystemFrame');

export default [
  {
    path: 'controlling',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: 'overview',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=277'
        }
      },
      {
        path: 'values',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=464&func=entryMonthlyData'
        }
      },
      {
        path: 'best-of',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=342&func=controllingTopEvaluation'
        }
      },
      {
        path: 'advertising',
        component: OldSystemFrame,
        props:{
          url: '/login/templates/content.php?id=472&func=showOverview'
        }
      },
    ]
  },
]
